import React from 'react';
import styled from 'styled-components';
import ReactTooltip, { TooltipProps } from 'react-tooltip';

const Tooltip = (props: TooltipProps) => {
  return (
    <Wrapper>
      <ReactTooltip {...props} />
    </Wrapper>
  );
};

export default Tooltip;

const Wrapper = styled.div`
  .__react_component_tooltip {
    border-radius: 4px;
    ${({ theme }) => theme.DF_TYPOGRAPHY.UI15M};
    font-size: 15px;
    font-weight: 500;
    color: ${({ theme }) => theme.DF_COLOR.GRAY10};
    background: ${({ theme }) => theme.DF_COLOR.GRAY900};
    width: auto;
  }
`;
